export const QBO_INVOICE_URL = 'https://app.qbo.intuit.com/app/invoice?txnId=';
export const QBO_JOURNAL_URL = ' https://app.qbo.intuit.com/app/journal?txnId=';
export const QBO_PAYMENT_URL =
  'https://app.qbo.intuit.com/app/recvpayment?txnId=';
export const QBO_CREDITMEMO_URL =
  'https://app.qbo.intuit.com/app/creditmemo?txnId=';
export const QBO_BILL_URL = ' https://app.qbo.intuit.com/app/bill?txnId=';
export const QBO_VENDORCREDIT_URL =
  'https://app.qbo.intuit.com/app/vendorcredit?txnId=';
